import { ViewModel,View, ViewModelMessage } from "binder"
import { DragDropPossibilityChecker, DropAppliedViewModelMessage } from "uicomponents";
import { FormBuilderComponent } from "../../components";
import { ChildAcceptableFormBuilderElement, ElementDecorator, FormBuilderElement } from "../../element";
import { DragableElementDecoratorView } from "../dragableElementDecorator/dragableElementDecorator-view";
import { DragableElementDecoratorViewModel } from "../dragableElementDecorator/dragableElementDecorator-viewModel";
import { CompactView } from "./compact-view";
import  { ComponentDropDecoratorView } from "./componentDropDecorator-view"

export class ComponentDropDecoratorViewModel extends ElementDecorator{
    constructor(parentViewModel: ViewModel) {
        super(parentViewModel);
    }
    GetDefaultView(): View <ViewModel> {
        return new ComponentDropDecoratorView();
    }
    public getTypeId(): string {
        return "VM-228638C0-405C-4343-B10B-C7602A2B32DC"
    }

    override handleMessage(message:ViewModelMessage){
        if(message instanceof DragDropPossibilityChecker){
            if(message.dragged instanceof FormBuilderComponent){
                return message.createAllowanceResponse("Allowed");
            }else if(message.dragged instanceof DragableElementDecoratorViewModel){
                return message.createAllowanceResponse("Allowed");
            }else{
                return super.handleMessage(message);
            }
        }else if(message instanceof DropAppliedViewModelMessage && message.dragged instanceof FormBuilderComponent){
            let element = message.dragged.Create(this.self);
            (<ChildAcceptableFormBuilderElement><any>this).addChild(element);
            return null;
        }else if(message instanceof DropAppliedViewModelMessage && message.dragged instanceof DragableElementDecoratorViewModel){
            let element = message.dragged.self;
            element.self.removeElementFromParent();
            let newElement = element.component.decorate(this.self,element.self); 
            (<ChildAcceptableFormBuilderElement><any>this).addChild(<any>newElement.decoratorHead);
            return null;
        }else{
            return super.handleMessage(message);
        }
    }

    getCompactViewForFormBuilderStructureViewDecorators(vm){
        return new CompactView();
    }

}
